export default "__VITE_ASSET__Clo6CdUq__"